<template>
  <div id="wrapper">
    <Nav :message="message" />
    <Note />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import Note from '@/components/tools/Note.vue'

export default {
  name: 'name-card',
  props: ['message'],
  components: {
    Nav,
    Note
  }
}
</script>